module.exports = __webpack_public_path__ + "static/media/testfile_llava.6e451e6c.zip";